import type { NovaEvent } from '@nova/types';
import type { MailboxInfo } from 'owa-client-types';
import type { AppHostServiceEventOriginator } from './originator';

export const OpenProfileEditorEventType = 'openProfileEditor' as const;

export type OpenProfileEditorData = {
    mailboxInfo: MailboxInfo;
    targetWindowId?: string;
};

export interface OpenProfileEditorEvent extends NovaEvent<OpenProfileEditorData> {
    originator: typeof AppHostServiceEventOriginator;
    type: typeof OpenProfileEditorEventType;
    data: () => OpenProfileEditorData;
}
